import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import FactorsTable from './components/FactorsTable';
import Overlay from '../../components/Overlay';
import API from '../../services/API';

class BidderWinRateConfig extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            sources: {},
            config: {},
            factors: [],
            params: [],
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleFactors = this.handleFactors.bind(this);
        this.handleTableHide = this.handleTableHide.bind(this);
    }

    componentDidMount() {
        API.BidderSources.getAvailableSourcesObj()
            .then((sources) => this.setState({ sources }));

        this.loadConfig();
    }

    loadConfig() {
        this.setState({ isLoading: true })

        API.BidderWinRateConfig.get().then(({ config }) => this.setState({ isLoading: false, config }))
    }

    loadFactors(source) {
        this.setState({ isLoading: true });

        API.BidderWinRateFactors.get(source)
            .then(({ params, factors }) => this.setState({ isLoading: false, params, factors }))
    }

    handleFormSubmit(source, enabled) {
        this.setState({ isLoading: true });

       API.BidderWinRateConfig.save(source, enabled).then(() => this.loadConfig());
    }

    handleFactors(source) {
        this.loadFactors(source);
    }

    handleTableHide() {
        this.setState({ factors: [], params: [] });
    }

    getFactorsTable() {
        const { params, factors } = this.state;

        if(factors && factors.length) {
            return (
                <Overlay onFormHide={this.handleTableHide}>
                    <FactorsTable params={params} factors={factors}/>
                </Overlay>
            )
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder Win Rate Config"/>

                {this.getFactorsTable()}

                <Table sources={this.state.sources} config={this.state.config} onUpdate={this.handleFormSubmit} onSort={this.handleSort} onFactors={this.handleFactors}/>
            </Container>
        );
    }
}

export default BidderWinRateConfig;


// WEBPACK FOOTER //
// ./src/scenes/BidderWinRateConfig/index.js